export const state = {
  incidents: [],
  selectedIncident: null
}

export const mutations = {
  SET_DATA(state, data) {
    state.incidents = data
  },
  SET_SELECTED_INCIDENT(state, incident) {
    state.selectedIncident = incident
  }
}

export const actions = {
  setIncidents({ commit }, data) {
    commit('SET_DATA', data)
  },
  setSelectedIncident({ commit }, incident) {
    commit('SET_SELECTED_INCIDENT', incident)
  }
}

export const namespaced = true
